import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-legend',
    templateUrl: './legend.component.html',
    styleUrls: ['./legend.component.scss'],
    standalone: false
})
export class LegendComponent implements OnInit {
  @Input() legendData: {[key: string]: string};
  constructor() { }

  ngOnInit(): void {
  }

  getKeys(): string[] {
    return Object.keys(this.legendData);
  }
  getBackgroundColor(key: string): any {
    const colorValue = this.legendData[key]['color'];
    return {'background-color': `${colorValue}`};
  }

  isCustom(key: any): boolean {
    return this.legendData[key]['isCustom'];
  }

  examName(key: any): boolean {
    return this.legendData[key]['examName'];
  }
  
}
